/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-hero-slider.get-names.ts 
*/
:host {
  box-sizing: border-box;
}
:host * {
  box-sizing: border-box;
}

.ace-hero-slider {
  position: relative;
  width: var(--ace-hero-slider-width, 100vw);
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: var(--ace-hero-slider-background-color, var(--ace-color-surface-glass--ambience-darken));
  -webkit-overflow-scrolling: touch; /* iOS */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  /* This allows custom styling on the slot */
}
.ace-hero-slider::-webkit-scrollbar {
  display: none;
  /* WebKit */
  height: 0;
  width: 0;
}
.ace-hero-slider ace-hero-item {
  width: var(--ace-hero-slider-width, 100vw);
  max-width: 100%;
}
.ace-hero-slider__slide {
  width: var(--ace-hero-slider-width, 100vw);
  max-width: 100%;
  opacity: 0;
  transition: opacity 1.5s;
}
.ace-hero-slider__slide--current {
  opacity: 1;
  transition: opacity 1.5s;
}
.ace-hero-slider__slide--current > section, .ace-hero-slider__slide--current ace-hero-item {
  height: 100%;
}
.ace-hero-slider__container {
  display: flex;
  position: relative;
  height: 100%;
  overflow-x: hidden;
  float: left;
}